import { useUpdate } from '@refinedev/core';

type Props = {
  clientId: string;
};

export const useConnectAsset = ({ clientId }: Props) => {
  const {
    mutateAsync: connectAssetMutation,
    isLoading,
    error,
    isError,
  } = useUpdate();

  const connectAsset = async (assetId: string) => {
    return await connectAssetMutation({
      resource: `clients/${clientId}/assets/${assetId}`,
      id: 'connect-to-feed',
      values: {},
    });
  };

  return {
    connectAsset,
    isLoading,
    error,
    isError,
  };
};
